import { React } from "react";
import {Link} from 'react-router-dom'
import { useSelector } from "react-redux";

import './Header.scss'
import JButton from '../../components/Button/JButton'

const Header = () => {

    const customer = useSelector(state => state.customer);

    return (
        <div>
            <div className="header">
                <div className="btn">
                    {/* <a className="fa fa-user" href="http://my.mahannet.ir" target="_blank">
                        <span>ورود مشترکین</span>
                    </a> */}
                    <JButton  title={!customer.isMobile0 ? "ورود مشترکین" : ""} href={"http://my.mahannet.ir"} leftIcon={"fa fa-user"} type={"LTE"} noSize={true} />
                </div>
                <Link className="logo" to="/"></Link>
                {/* <div className="logo"></div> */}
            </div>
            <div className="subHeader">
                <div className="site">
                    <i className="fa fa-globe"></i>
                    <a href="http://mahannet.ir" target="_blank">سایت ماهان نت</a>
                </div>
                <div className="store">
                    <i className="mainColor fa fa-shopping-cart"></i>
                    <span className="mainColor">فروشگاه</span>
                </div>
                <div className="phone">
                    <a href="tel:1514" target="_blank">۱۵۱۴</a>
                    <i className="mainColor fa fa-volume-control-phone"></i>
                </div>
            </div>
        </div>
    );
}

export default Header;
